import { forwardRef } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { MapPinIcon } from '@heroicons/react/24/outline';


type GeolocationButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export const GeolocationButton = forwardRef<
  HTMLButtonElement,
  GeolocationButtonProps
>((props, ref) => {
  return (
    <Button
      ref={ref}
      variant="icon"
      ariaLabel="Use a geolocation"
      dataTestId="geolocation-button"
      className="rounded-md border border-gray-300"
      {...props}
    >
      <MapPinIcon className="h-6 w-6" />
    </Button>
  );
});

GeolocationButton.displayName = 'GeolocationButton';
